module.exports = __webpack_public_path__ + "static/img/bus-icon-1.d1de2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bus-icon-1.png
// module id = GIpR
// module chunks = 0